import { useState, useEffect } from 'react';
import useApi from 'vl-common/src/hooks/useApi';

interface Speciality {
  cat_code: string;
  cat_name: string;
  enabled: boolean;
  needs_card_details: number;
  no_areas: number;
  no_users: number;
}

interface SubSpeciality {
  category_code: string;
  category_name: string;
  area_code: string;
  area_name: string;
  image_url?: string;
  enabled: boolean;
  no_users: number;
  cat_no_users: number;
}

export default function useFetchSpecialityAndSubSpeciality() {
  const { Api } = useApi();
  const [specialities, setSpecialities] = useState<Speciality[]>([]);
  const [subSpecialities, subSetSpecialities] = useState<SubSpeciality[]>([]);

  useEffect(() => {
    const fetchSpecialtyDropdown = () => {
      Api.admin
        .getSpecialistCategory({ rows: 999 })
        .then((res) => {
          const { data } = res;
          const { cats } = data || { cats: [] };
          setSpecialities(cats);
        })
        .catch((e) => {
          // No groups found
          setSpecialities([]);
        });
    };
    fetchSpecialtyDropdown();
  }, []);

  useEffect(() => {
    const fetchSubSpecialtyDropdown = () => {
      Api.admin
        .getSpecificAreas({ rows: 999 })
        .then((res) => {
          const { data } = res;
          const { areas } = data || { areas: [] };
          subSetSpecialities(areas);
        })
        .catch((e) => {
          // No groups found
          subSetSpecialities([]);
        });
    };
    fetchSubSpecialtyDropdown();
  }, []);

  return [specialities, subSpecialities] as const;
}
